import { render, staticRenderFns } from "./CapturedImgList.vue?vue&type=template&id=2566b423&"
import script from "./CapturedImgList.vue?vue&type=script&lang=js&"
export * from "./CapturedImgList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports